import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "modules/i18n/hooks/useTranslations";

/**
 * Privacy policy footer component.
 * Shows links to privacy policy and terms of service.
 */
export const PrivacyPolicyFooter = () => {
  "use memo";

  const $ = _c(4);
  const t = useTranslations("newsletters");
  let t0;
  if ($[0] !== t) {
    t0 = t("privacy_policy_html");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="mx-auto mt-2 max-w-2xl text-center text-sm text-gray-600" dangerouslySetInnerHTML={{
      __html: t0
    }} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};